import { useSearchParams } from 'react-router-dom';

/** Small "payment received" notice on the dashboard after Stripe Checkout (/?checkout=success). */
export default function CheckoutNotice() {
  const [params, setParams] = useSearchParams();
  if (params.get('checkout') !== 'success') return null;
  const dismiss = () => {
    const next = new URLSearchParams(params);
    next.delete('checkout');
    setParams(next, { replace: true });
  };
  return (
    <div role="status" className="bg-blue-soft border border-blue/30 text-ink px-4 py-3 rounded-xl text-[15px] flex items-start gap-3">
      <span className="flex-1">
        <strong className="font-semibold">Payment received. Thank you!</strong>{' '}
        Your plan switches on as soon as Stripe confirms it, usually within a minute.
      </span>
      <button type="button" onClick={dismiss} className="text-sm font-semibold text-blue hover:underline shrink-0">Dismiss</button>
    </div>
  );
}
